import { useCallback } from 'react';
import { useAuthContext } from '../auth/useAuthContext';
import Popup from '../../services/popup/popup';
import { PopupType } from '../../utilities/constants/popup-type';
import usePreAuthAction, { PreAuthAction } from '../usePreAuthAction';
import { useEditorContext } from '../editor/useEditorContext';
import { LoginEventPopupFlow } from '../../utilities/constants/common';

export const useOpenSubscriptionPopup = () => {
  const { userId } = useAuthContext();
  const { setPreAuthAction } = usePreAuthAction();

  const { generationSubjectGroup } = useEditorContext();

  const handleOpenSubscriptionPopup = useCallback(() => {
    if (!userId) {
      setPreAuthAction(PreAuthAction.SHOW_AI_TOOLS_SUBSCRIPTION_POPUP);
      Popup.show(PopupType.LOGIN, { flow: LoginEventPopupFlow.OTHER });
      return;
    }

    Popup.show(PopupType.AI_TOOLS_SUBSCRIPTION, {
      subjectGroup: generationSubjectGroup,
    });
  }, [userId, setPreAuthAction, generationSubjectGroup]);

  return {
    handleOpenSubscriptionPopup,
  };
};
